module.exports = __webpack_public_path__ + "static/img/benzbmw_en.aa30f35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/benzbmw_en.png
// module id = B69Q
// module chunks = 1